import { Alert, Button, Grid, Typography } from "@mui/material";
import { FormEvent, useState } from "react";
import { ValidatorForm } from 'react-material-ui-form-validator';
import { useNavigate } from "react-router";
import { PaperHeader } from "../../_components/paper/header.paperComponent";
import { accountService } from "../../_services/accounts.service";
import { theme } from "../../_styles/theme.styles";
import { Link, useLocation } from "react-router-dom";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { PrimaryButton } from "../../_components/button/primary.button";

const useStyles = {
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: theme.spacing(2),
    },
    form: {
        width: '100% !important', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    header: {
        marginLeft: theme.spacing(-8),
    },
    mainBackground: {
    },

    logo: {
        width: "100%",
        height: "100px",
    },
    backToLogin: {
        paddingTop: "20px",
        cursor: "pointer"
    }
};

export function LoginVerifyCode() {

    let navigate = useNavigate();
    let { pathname } = useLocation();
    let email = pathname && pathname.indexOf("email=") ? pathname.split("email=")[1] : "";

    const [isLoading, setLoading] = useState(false);
    const [code, setCode] = useState("");
    const [warning, setWarning] = useState("");
    const [isLockedOut, setIsLockedOut] = useState(false);

    function submit(e: FormEvent) {
        e.preventDefault();
        setLoading(true);

        accountService.verifyCode(email, code)
            .then(
                (item => {
                    if (accountService.isAdmin) {
                        window.location.href = "/Users";
                    }
                    else if (accountService.isUser || accountService.isOrganiser) {
                        window.location.href = `/`;
                    }
                }),
                ((err) => {
                    setIsLockedOut(true);
                    setWarning(err);
                }))
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <div style={useStyles.paper as React.CSSProperties}>
            <div style={useStyles.header}>
                <PaperHeader title='Verify Code' icon='lock'></PaperHeader>
            </div>

            <Alert severity="warning">
                <Typography>
                    Multi-factor authentication is required to login to this account.
                    A verification code has been sent to the email address for this account.
                    Please enter the verification code to login. <br /> <br />

                    This may take few minutes.
                </Typography>
            </Alert>

            {isLockedOut === true &&
                <Alert severity="error">
                    {warning}
                </Alert>
            }

            <ValidatorForm sx={useStyles.form} onSubmit={submit} noValidate>

                <Grid container>

                    <Grid item xs={12}>

                        <TextValidatorHcs
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Verification Code"
                            name="code"
                            value={code}
                            disabled={isLoading}
                            onChange={(e: any) => setCode(e.target.value.toString())}
                            validators={['required']}
                            errorMessages={['This field is required']}
                            autoFocus
                        />
                    </Grid>


                    <Grid item xs={12}>
                        <PrimaryButton
                            type="submit"
                            variant="primary"
                            disabled={isLoading}
                        >
                            Submit
                        </PrimaryButton>
                    </Grid>

                </Grid>

            </ValidatorForm>

            <Link to={"/login"} style={useStyles.backToLogin}>
                Back to Log In screen
            </Link>

        </div>
    );
}